export default {"src":"/venues/_next/static/media/Error404.04a8be05.svg","height":306,"width":390,"blurWidth":0,"blurHeight":0};